import { Box } from "@bigcommerce/big-design";
import styled from "styled-components";

export const StyledBox = styled(Box)`
   height: inherit;
`;